import { BaseService } from "./BaseService";

export const ExercicioService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('exercicio/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos exercícios:', error);
            return false;
        }
    },
    async select() {
        try {
            return await BaseService.fetchResponseFromAPIGet('exercicio/select');
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos exercícios:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('exercicio', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de exercício:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`exercicio/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de exercício:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`exercicio/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de exercício:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('exercicio/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir exercício(s):', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('exercicio/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar exercício(s):', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('exercicio/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar exercício(s):', error);
            return false;
        }
    }, 
}